<template>
    <div class="modal">
        <div class="modal-container">
            <div class="modal-header">
                <close-icon v-on:click="closeView"></close-icon>
                <h1>Copify Job</h1>
            </div>

            <div class="modal-body no-pad" v-if="job">
                <div class="flex h-full">
                    <div class="w-full">
                        <div class="modal-body-content">
                            <div class="mb-3">
                                <label class="block text-gray-800 text-sm mb-2">Requested</label>
                                <p>{{ job.created }}</p>
                            </div>

                            <div class="mb-3 status">
                                <label class="block text-gray-800 text-sm mb-2">Status</label>
                                <span :class="buildCssClass(getStatusForJob(job))">{{ getStatusForJob(job) }}</span>
                            </div>

                            <div class="mb-3">
                                <label class="block text-gray-800 text-sm mb-2">Brief</label>
                                <textarea
                                    rows="5"
                                    class="appearance-none border w-full py-2 px-3 text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
                                >{{ job.brief }}</textarea>
                            </div>

                            <div class="mb-3">
                                <label class="block text-gray-800 text-sm mb-2">Headline</label>
                                <input
                                    type="text"
                                    :value="job.title"
                                    class="appearance-none border w-full py-2 px-3 text-gray-800 leading-tight focus:outline-none focus:shadow-outline"/>
                            </div>

                            <div class="mb-3">
                                <label class="block text-gray-800 text-sm mb-2">Body</label>
                                <textarea
                                    rows="5"
                                    class="appearance-none border w-full py-2 px-3 text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
                                >{{ job.copy }}</textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <div class="flex">
                    <div class="left text-left">

                    </div>

                    <div class="middle text-middle">

                    </div>

                    <div class="right text-right">
                        <button class="btn-tertiary muted" type="button" @click="closeView">Cancel</button>
                    </div>
                </div>
            </div>
            <router-view v-slot="{ Component }">
                <transition name="drop-in" mode="in-out">
                    <component :is="Component"></component>
                </transition>
            </router-view>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CopifyJob',
    data() {
        return {
            job: null,
            statuses: null,
        }
    },
    mounted() {
        this.setMetaTitle('Copify Job | JournoLink Control')

        this.loadData()
    },
    methods: {
        getStatuses() {
            return axios.get(route('professionalWriting.copify.statuses'))
        },
        getJob() {
            return axios.get(route('professionalWriting.copify.job', { jobId: this.$route.params.jobId }))
        },
        loadData() {
            axios.all([this.getJob(), this.getStatuses()])
                .then(axios.spread((responseWriting, responseStatus) => {
                    this.job = responseWriting.data
                    this.statuses = responseStatus.data
                }))
                .catch(e => {
                    this.$bus.$emit('alert.danger', 'There was an error retrieving professional writing requests')
                })
        },
        /**
         * Emit the close event to the parent
         *
         * @return {void}
         */
        closeView() {
            this.$root.goBack()
        },
        /**
         * Handle an [Escape] keypress
         *
         * @return {void}
         */
        onEscapeKeypress() {
            this.closeView()
        },
        /**
         * create some css classes for each status
         * @param  {string} status
         * @return {string} css friendly status
         */
        buildCssClass(status) {
            return status?.toLowerCase().replace(' ', '-')
        },
        /**
         * Retrieve the status text for the given job
         *
         * @param job
         * @return {*|string}
         */
        getStatusForJob(job) {
            let status = this.statuses.find(item => parseInt(item.id) === parseInt(job.job_status_id))

            return status?.name ?? 'Unknown'
        },
    },
}
</script>

<style lang="less">
.status {
    span {
        padding: 5px;
        border-radius: 3px;
        color: white;
    }

    .open,
    .in-progress,
    .rewrite-requested,
    .requires-edits,
    .paused,
    .scheduled {
        background: #2980b9;
    }

    .approved,
    .completed,
    .pending-accept {
        background: #2c3e50;
    }
}
</style>

